import {Contact} from "./Contact";
import {ProjectSettings} from "./ProjectSettings";

export const projectRelationTypeOptions = {
  "Aanvrager": "Aanvrager",
  "Opdrachtgever": "Opdrachtgever",
  "Eindklant": "Eindklant",
  "Onderaannemer": "Onderaannemer",
  "Leverancier": "Leverancier",
  "Uitvoerder": "Uitvoerder",
  "Particulier": "Particulier",
  "Overige": "Overige",
  'primary': 'Primair (Oud / Proteus)',
  'customer': 'Klant (Oud / Proteus)',
  'delivery': 'Levering (Oud / Proteus)',
  'other': 'Anders (Oud / Proteus)',
}
export type RelationType = keyof typeof projectRelationTypeOptions;

export const projectRelationStatusOptions = {
  'open': 'Open',
  'accepted': 'Aangenomen',
  'inactive': 'Vervallen',
  'archived': 'Gearchiveerd',
}

export type ProjectRelationStatus = keyof typeof projectRelationStatusOptions;

export class ProjectRelation {
  constructor(
    public readonly id: string,
    public readonly projectId: string,
    public readonly relationId: string,
    public readonly relationStatus: ProjectRelationStatus,
    public readonly relationType: RelationType,
    public readonly contacts: Contact[],
    public readonly projectSettings: ProjectSettings|null,
    public readonly createdAt: Date,
    public readonly updatedAt: Date
  ) {
  }

  static fromJson(json: any): ProjectRelation {
    return new ProjectRelation(
      json['id'],
      json['project_id'],
      json['relation_id'],
      json['relation_status'],
      json['relation_type'],
      json['contacts'] ? json['contacts'].map((c: any) => Contact.fromJson(c)) : [],
      json['project_settings'] ? ProjectSettings.fromJson(json['project_settings']) : null,
      new Date(json['created_at']),
      new Date(json['updated_at']),
    )
  }

  getIsActive(): boolean {
    return this.relationStatus !== 'archived' && this.relationStatus !== 'inactive'
  }
  getRelationTypeText(): string {
    return projectRelationTypeOptions[this.relationType] ?? this.relationType
  }
  getRelationStatusText(): string {
    return projectRelationStatusOptions[this.relationStatus] ?? this.relationStatus
  }
}